import React from "react";


const ConfirmedOrderInfo = ({confirmedOrder,invoiceContact,deliveryContact}) => {
	let T = window.Texts.contactForm;
return (
	<div className="prow order-details">
	<div className="pcol span-1 h">
		<h3>{T.sendToYourAddress}</h3>
		{invoiceContact.isCompany ?
			<p>
				<span>{invoiceContact.companyName}</span>
				<>{'IČ: ' + invoiceContact.companyIdNumber}</>

				{invoiceContact.companyTaxNumber ?
					<><br /> {'DIČ: ' + invoiceContact.companyTaxNumber}</> : null}
			</p> : null}

		<p>
			<span>
				{deliveryContact.firstName + ' ' + deliveryContact.lastName}
			</span>
			<span>{deliveryContact.address} </span><br />
			<span>{deliveryContact.zip}</span>
			<span>{deliveryContact.city} </span><br />
			<span>{deliveryContact.country.name}</span>
		</p>
	</div>
	<div className="pcol span-1">
		<h3>{T.deliveryService}</h3>
		<p>
			<span>{confirmedOrder.shipping.name}</span>
			{(confirmedOrder.store) ? <span>{confirmedOrder.store.title}</span> : null}
		</p>
	</div>
	<div className="pcol span-1">
		<h3>{T.payment}</h3>
		<p>
			<span>{confirmedOrder.payment.name}</span>
		</p>
	</div>
</div>
);
}

export default ConfirmedOrderInfo;
